import { gql } from '@apollo/client';

export const QUERY_GET_TENANTS = gql`
    query TenantsQuery {
        getTenants {
            id
            name
            description
            url
            tenantType {
                id
                name
            }
            parent {
                id
                name
            }
            coverageZone {
                id
                name
            }
            enabled
            children {
                id
                name
            }
            users {
                id
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export const QUERY_FIND_TENANT = gql`
    query TenantFind($data: TenantFindInput!) {
        findTenant(data: $data) {
            id
            name
            tenantType {
                id
                name
                tag
                enabled
            }
            associatedEntities {
                id
            }
            whitelistedDomains {
                domain
            }
        }
    }
`;

export const FIND_TENANT = gql`
    query FindTenant($data: TenantFindInput!) {
        findTenant(data: $data) {
            id
            url
            name
            description
        }
    }
`;

export const QUERY_FIND_TENANT_BY_URL = gql`
    query Query($url: String!) {
        findTenantByUrl(url: $url)
    }
`;
